// LEGACY UI: replace with Field with Checkbox from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).

import FormError from "@casino/legacyUi/form/FormError";
import { FormItem } from "@casino/legacyUi/form/FormItem";
import { forwardRef } from "react";
import CustomCheckbox from "./styles/CustomCheckbox";

type Props = {
  label?: string;
  checked?: boolean;
  error?: string;
  disabled?: boolean;
  onClick?: () => void;
};

const FormCheckbox = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { error = "" } = props;
  return (
    <FormItem>
      <CustomCheckbox ref={ref} {...props} />
      {error && <FormError className="relative bottom-2" message={error} />}
    </FormItem>
  );
});

export default FormCheckbox;
